import { render, staticRenderFns } from "./TopUpPackageModal.vue?vue&type=template&id=3c64e9ba&scoped=true"
import script from "./TopUpPackageModal.vue?vue&type=script&lang=js"
export * from "./TopUpPackageModal.vue?vue&type=script&lang=js"
import style0 from "./TopUpPackageModal.vue?vue&type=style&index=0&id=3c64e9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c64e9ba",
  null
  
)

export default component.exports